import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";
import { getTextDirection } from "../i18n";
import NavSectionItem from "./NavSectionItem";

const titleMatchesQuery = (title, query) => {
  const h = String(title || "");
  const q = String(query || "").trim();
  if (!q) return true;
  try {
    if (h.toLocaleLowerCase("ur").includes(q.toLocaleLowerCase("ur"))) {
      return true;
    }
  } catch {
    // ignore
  }
  return h.toLowerCase().includes(q.toLowerCase());
};

export default function NavSection({ navConfig }) {
  const { t, i18n } = useTranslation();
  const textDir = getTextDirection(i18n.resolvedLanguage || i18n.language);
  const [searchText, setSearchText] = useState("");

  const filteredGroups = useMemo(() => {
    if (!searchText.trim()) return navConfig || [];

    return (navConfig || [])
      .map((group) => ({
        ...group,
        items: (group.items || []).filter((item) =>
          titleMatchesQuery(item.title, searchText),
        ),
      }))
      .filter((group) => group.items.length > 0);
  }, [navConfig, searchText]);

  const flatResults = useMemo(() => {
    if (!searchText.trim()) return null;
    return (navConfig || [])
      .flatMap((group) => group.items || [])
      .filter((item) => titleMatchesQuery(item.title, searchText));
  }, [navConfig, searchText]);

  return (
    <div className="sidebar-nav">
      <div className="sidebar-nav__search">
        <SearchIcon className="sidebar-nav__search-icon" fontSize="small" />
        <input
          type="text"
          dir={textDir}
          lang={i18n.resolvedLanguage || i18n.language}
          placeholder={t("nav.searchMenu")}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          aria-label={t("nav.searchMenu")}
        />
      </div>

      <nav className="sidebar-nav__menu" aria-label={t("header.sidebarLandmark")}>
        {flatResults
          ? flatResults.map((item) => (
              <NavSectionItem key={item.path} data={item} />
            ))
          : filteredGroups.map((group) => (
              <div key={group.labelKey || group.label} className="sidebar-nav__group">
                <p className="sidebar-nav__group-label">{group.label}</p>
                {(group.items || []).map((item) => (
                  <NavSectionItem key={item.path} data={item} />
                ))}
              </div>
            ))}
      </nav>
    </div>
  );
}
